import React, { useEffect, useState } from 'react';
import { reportProps } from './StopLossAggregateTable';
import {
  TotalSpend,
  TotalEnrolled,
  formatTotalEnrolled,
  formatTotalSpend,
  AverageAge,
  formatAvgAge,
  formatGender,
  Gender,
} from '../core-utils/helper-utils/summaryReportHelper';
import summaryPageConstants from '../core-utils/messages/summaryPageConstants';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Add,
  CardComponent,
  Equal,
  Female,
  Male,
  MoneyBag,
  SvgEmployee,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import {
  LabelValueColumn,
  Typography,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';

const EnrollmentTopCards: React.FC<reportProps> = ({ data }) => {
  const messages = summaryPageConstants.SUMMARY_PAGE.SUMMARY_CARDS;
  // const [loading, setLoading] = useState<boolean>(false);

  const [totalEnrolled, setTotalEnrolled] = useState<TotalEnrolled>({
    totalCount: '',
    dependents: '',
    employees: '',
  });
  const [totalSpend, setTotalSpend] = useState<TotalSpend>({
    totalSpend: '',
    employeeSpend: '',
    dependentSpend: '',
  });

  const [avgAge, setavgAge] = useState<AverageAge>({
    allMembers: '',
    employee: '',
    dependent: '',
  });

  const [gender, setGender] = useState<Gender>({
    allMale: '',
    allFemale: '',
    maleDependent: '',
    femaleDependent: '',
    maleEmployee: '',
    femaleEmployee: '',
  });

  const labelStyleProps = {
    fontSize: '14px',
    color: patientAccessTheme.palette.text.mediumemphasis,
  };
  const valueStyleProps = {
    fontSize: '16px',
    color: patientAccessTheme.palette.text.highemphasis,
    fontWeight: 600,
  };

  const useStyles = makeStyles()({
    set: {
      display: 'flex',
      alignItems: 'center',
    },
  });

  const { classes } = useStyles();

  useEffect(() => {
    setTotalEnrolled(formatTotalEnrolled(data?.eligibleData));
    setavgAge(formatAvgAge(data?.eligibleData));
    setGender(formatGender(data?.eligibleData));
    setTotalSpend(formatTotalSpend(data?.employeeDependentSpend, 0));
  }, []);
  return (
    <Grid style={{ display: 'flex', flexDirection: 'column' }}>
      <Grid style={{ display: 'flex', marginBottom: '24px', gap: '32px' }}>
        <CardComponent
          title={''}
          width={'40%'}
          body={
            <Grid style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Grid className={classes.set}>
                <SvgEmployee style={{ width: '30px', height: '30px' }} />
              </Grid>
              <Grid className={classes.set}>
                <LabelValueColumn
                  label={messages.TOTAL_ENROLLED}
                  value={totalEnrolled?.totalCount}
                  labelTypographyProps={labelStyleProps}
                  valueTypographyProps={valueStyleProps}
                />
              </Grid>
              <Grid className={classes.set}>
                <LabelValueColumn
                  label={'Employee'}
                  value={totalEnrolled?.employees}
                  labelTypographyProps={labelStyleProps}
                  valueTypographyProps={valueStyleProps}
                />
              </Grid>
              <Grid className={classes.set}>
                <LabelValueColumn
                  label={'Dependent'}
                  value={totalEnrolled?.dependents}
                  labelTypographyProps={labelStyleProps}
                  valueTypographyProps={valueStyleProps}
                />
              </Grid>
            </Grid>
          }
        />
        <CardComponent
          title={''}
          width="60%"
          body={
            <Grid style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Grid className={classes.set}>
                <MoneyBag style={{ width: '30px', height: '30px' }} />
              </Grid>
              <Grid className={classes.set}>
                <LabelValueColumn
                  label={messages.TOTAL_SPEND}
                  value={totalSpend?.totalSpend}
                  labelTypographyProps={labelStyleProps}
                  valueTypographyProps={valueStyleProps}
                />
              </Grid>
              <Grid className={classes.set}>
                <Equal />
              </Grid>
              <Grid className={classes.set}>
                <LabelValueColumn
                  label={'Employee Spend'}
                  value={totalSpend?.employeeSpend}
                  labelTypographyProps={labelStyleProps}
                  valueTypographyProps={valueStyleProps}
                />
              </Grid>
              <Grid className={classes.set}>
                <Add
                  style={{ width: '31px', height: '31px' }}
                  fill={patientAccessTheme.palette.status.icon}
                />
              </Grid>
              <Grid className={classes.set}>
                <LabelValueColumn
                  label={messages.DEPENDENT_SPEND}
                  value={totalSpend?.dependentSpend}
                  labelTypographyProps={labelStyleProps}
                  valueTypographyProps={valueStyleProps}
                />
              </Grid>
            </Grid>
          }
        />
      </Grid>
      <Grid style={{ display: 'flex', marginBottom: '24px', gap: '32px' }}>
        <CardComponent
          title={'Average Ages'}
          width="35%"
          body={
            <Grid
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '5px',
              }}
            >
              <Grid className={classes.set}>
                <LabelValueColumn
                  label={messages.ALL_MEMBERS}
                  value={avgAge?.allMembers}
                  labelTypographyProps={labelStyleProps}
                  valueTypographyProps={valueStyleProps}
                />
              </Grid>
              <Grid className={classes.set}>
                <LabelValueColumn
                  label={messages.EMPLOYEES}
                  value={avgAge?.employee}
                  labelTypographyProps={labelStyleProps}
                  valueTypographyProps={valueStyleProps}
                />
              </Grid>
              <Grid className={classes.set}>
                <LabelValueColumn
                  label={messages.DEPENDENTS}
                  value={avgAge?.dependent}
                  labelTypographyProps={labelStyleProps}
                  valueTypographyProps={valueStyleProps}
                />
              </Grid>
            </Grid>
          }
        />
        <CardComponent
          title={messages.GENDER}
          width="65%"
          body={
            <Grid style={{ display: 'flex', gap: '50px', marginTop: '5px' }}>
              <Grid
                className={classes.set}
                style={{
                  borderRight: `1px solid ${patientAccessTheme.palette.grey[300]}`,
                }}
              >
                <LabelValueColumn
                  label={messages.ALL_MEMBERS}
                  value={
                    <Grid
                      container
                      style={{
                        alignItems: 'center',
                        gap: '8px',
                        marginRight: '40px',
                      }}
                    >
                      <Male style={{ height: '30px', width: '30px' }} />
                      <Typography
                        style={{ ...valueStyleProps, marginRight: '18px' }}
                      >
                        {gender.allMale}
                      </Typography>
                      <Female style={{ height: '30px', width: '30px' }} />
                      <Typography style={valueStyleProps}>
                        {gender.allFemale}
                      </Typography>
                    </Grid>
                  }
                  labelTypographyProps={labelStyleProps}
                  valueTypographyProps={valueStyleProps}
                  labelStyleProps={{ display: 'flex', justifyContent: 'left' }}
                />
              </Grid>
              <Grid
                className={classes.set}
                style={{
                  borderRight: `1px solid ${patientAccessTheme.palette.grey[300]}`,
                }}
              >
                <LabelValueColumn
                  label={messages.EMPLOYEES}
                  value={
                    <Grid
                      container
                      style={{
                        alignItems: 'center',
                        gap: '8px',
                        marginRight: '40px',
                      }}
                    >
                      <Male style={{ height: '30px', width: '30px' }} />
                      <Typography
                        style={{ ...valueStyleProps, marginRight: '18px' }}
                      >
                        {gender.maleEmployee}
                      </Typography>
                      <Female style={{ height: '30px', width: '30px' }} />
                      <Typography style={valueStyleProps}>
                        {gender.femaleEmployee}
                      </Typography>
                    </Grid>
                  }
                  labelTypographyProps={labelStyleProps}
                  valueTypographyProps={valueStyleProps}
                  labelStyleProps={{ display: 'flex', justifyContent: 'left' }}
                />
              </Grid>
              <Grid className={classes.set}>
                <LabelValueColumn
                  label={messages.DEPENDENTS}
                  value={
                    <Grid
                      container
                      style={{
                        alignItems: 'center',
                        gap: '8px',
                      }}
                    >
                      <Male style={{ height: '30px', width: '30px' }} />
                      <Typography
                        style={{ ...valueStyleProps, marginRight: '18px' }}
                      >
                        {gender.maleDependent}
                      </Typography>
                      <Female style={{ height: '30px', width: '30px' }} />
                      <Typography style={valueStyleProps}>
                        {gender.femaleDependent}
                      </Typography>
                    </Grid>
                  }
                  labelTypographyProps={labelStyleProps}
                  valueTypographyProps={valueStyleProps}
                  labelStyleProps={{ display: 'flex', justifyContent: 'left' }}
                />
              </Grid>
            </Grid>
          }
        />
      </Grid>
    </Grid>
  );
};
export default EnrollmentTopCards;
